/**
 * Corrige texto UTF-8 interpretado como Latin-1/Windows-1252 e
 * variantes comuns em PT-BR (ex.: "Refeição" → "RefeiÃ§Ã£o" / "Refeißão").
 *
 * Nota: "Água" costuma vir certo no banco (U+00C1). "ção" é o trecho
 * que tipicamente veio corrompido do import/API — por isso um acento
 * funciona e o outro não no mesmo dropdown.
 */
export function fixMojibake(input: string): string {
  if (!input) return input;

  let text = applyPortugueseMojibakeReplacements(input);

  for (let i = 0; i < 3; i++) {
    if (!looksLikeMojibake(text)) break;
    try {
      const bytes = Uint8Array.from(text, c => c.charCodeAt(0) & 0xff);
      const next = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      if (next === text) break;
      text = next;
    } catch {
      break;
    }
  }

  // Depois do decode: "ÃŸÃ£o" vira "ßão" (C3 DF = ß) — ainda precisa de fix
  text = applyPortugueseMojibakeReplacements(text);

  return text;
}

/**
 * Substituições explícitas. Ordem importa: padrões longos primeiro.
 * Cobre:
 * - mojibake clássico: Ã§Ã£ / Ã§Ã£o
 * - § (0xA7) e £ (0xA3) dos bytes UTF-8 de "ção"
 * - ß (0xDF) no lugar de § (decode parcial ou dado sujo)
 */
function applyPortugueseMojibakeReplacements(input: string): string {
  return (
    input
      // "ção" — combinações recorrentes
      .replace(/Ã§Ã£o/g, 'ção')
      .replace(/ÃŸÃ£o/g, 'ção')
      .replace(/Ã§Â£o/g, 'ção')
      .replace(/ÃŸÂ£o/g, 'ção')
      .replace(/Ã§£o/g, 'ção')
      .replace(/ÃŸ£o/g, 'ção')
      .replace(/§Ã£o/g, 'ção')
      .replace(/ßÃ£o/g, 'ção')
      .replace(/§£o/g, 'ção')
      .replace(/ß£o/g, 'ção')
      .replace(/§ão/g, 'ção')
      .replace(/ßão/g, 'ção')
      // glifos já destruídos na UI ("?ß?£o")
      .replace(/\?ß\?£o/gi, 'ção')
      .replace(/\?§\?£o/gi, 'ção')

      // "ç" / "ã" / acentos comuns
      .replace(/Ã§/g, 'ç')
      .replace(/Ã‡/g, 'Ç')
      .replace(/Ã£/g, 'ã')
      .replace(/Ã¡/g, 'á')
      .replace(/Ã©/g, 'é')
      .replace(/Ã­/g, 'í')
      .replace(/Ã³/g, 'ó')
      .replace(/Ãº/g, 'ú')
      .replace(/Ã¢/g, 'â')
      .replace(/Ãª/g, 'ê')
      .replace(/Ã´/g, 'ô')
      .replace(/Ã¼/g, 'ü')
      .replace(/Ã±/g, 'ñ')
      .replace(/Â°/g, '°')
      .replace(/ÃŸ/g, 'ç')
  );
}

function looksLikeMojibake(input: string): boolean {
  return /Ã.|Â[\x80-\xbf]|ÃŸ|[§ß][£ã]|ßão|§ão|\?ß\?£|\?§\?£/.test(input);
}

/** Remove acentos e baixa para comparação estável. */
export function stripAccentsLower(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}
